export default "__VITE_ASSET__22b638b4__"